export const splitDate = (date) => {
	const array = date.split('/');
	return {
		year: array[0],
		month: array[1],
		day: array[2]
	}
}